import React, { useEffect } from "react";
import { Box, Typography, TextField, Button } from "@mui/material";
import { useSelector } from "react-redux";
import { ShiftType } from "../../../types";
import { RootState, useAppDispatch } from "../../../redux/store";
import { getSwapEmployees, getSwapEmployeesV2 } from "../../../redux/features/schedule/ScheduleApi";
import { setFilterStartDate, setFilterEndDate } from "../../../redux/features/schedule/ScheduleSlice";
import { DateTimeUtil } from "../../../utils";
import { IUser } from "../../../redux/features/user/models/user";

const TradeShiftInitialStep: React.FC<{ onContinue: () => void; setNote: (text: string) => void }> = ({
    onContinue,
    setNote,
}) => {
    const selectedShift = useSelector((state: any) => state.schedule.selectedShift) as ShiftType;
    const dispatch = useAppDispatch();
    const User = useSelector((state: RootState) => state.user.user);
    const actionConsecutiveDays = useSelector((state: RootState) => state.schedule.actionConsecutiveDays);
    const getEffectiveActionConsecutiveDays = actionConsecutiveDays > 1 ? actionConsecutiveDays - 1 : undefined;

    useEffect(() => {

        const startDate = DateTimeUtil.ParseWithDayjsUtc(selectedShift.osEmpStartDateTime!);
        const endDate = new Date(selectedShift.osEmpStartDateTime!);
        endDate.setDate(endDate.getDate() + 7);
        dispatch(setFilterStartDate(startDate.toISOString()));
        dispatch(setFilterEndDate(endDate.toISOString()));
        // const now  = DateTimeUtil.formatDateToMySQL(new Date());
        const payload = {
            request_type: 1,
            start_date: startDate.toISOString(),
            end_date: endDate.toISOString(),
            assigned_shift_code: selectedShift.osShiftCode || "",
            department_code: User.departmentCode ?? User.departmentCode ?? User.department_code ?? User.department?.department_code ?? "",
            assigned_department_code: User.departmentCode ?? User.departmentCode ?? User.department_code ?? User.department?.department_code ?? "",
            group_code: [],
            name_search: "",
            days_in_swapping_block: actionConsecutiveDays,
            schedule_id: `${selectedShift.id}`,
        };

        // dispatch(getSwapEmployees(payload));

        dispatch(getSwapEmployeesV2(payload));
    }, []);

    return (
        <Box>
            <Box
                sx={{
                    // border: "1px solid rgba(0, 0, 0, 0.12)",
                    // padding: 2,
                    marginTop: 1,
                    backgroundColor: "#ffffff",
                }}
            >
                <Box
                    sx={{
                        border: "1px solid rgba(0, 0, 0, 0.12)",
                        padding: 1,
                        backgroundColor: "#f9f9f9",
                        marginBottom: 2,
                    }}
                >
                    <Typography variant="body2" gutterBottom>
                        {/* {selectedShift.osEmpStartDateTime} - {selectedShift.osEmpEndDateTime} */}
                        {DateTimeUtil.formatDateTimeRangeUtc(
                            selectedShift.osEmpStartDateTime!,
                            selectedShift.osEmpEndDateTime!
                        )}
                        {getEffectiveActionConsecutiveDays ? ` + ${getEffectiveActionConsecutiveDays} days` : ""}
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                        {selectedShift.osEmployeeProfile?.osEmpFirstName}{" "}
                        {selectedShift.osEmployeeProfile?.osEmpLastName}
                    </Typography>
                </Box>
                <Typography variant="body2" gutterBottom>
                    1. Submit a Swap Request – Select the shift you want to trade and choose available shifts from other
                    employees. A reason for the request may be required based on company policy.
                </Typography>
                <Typography variant="body2" gutterBottom>
                    2. Approval Process – Your request will go through an approval workflow, which may include managers,
                    supervisors, or other designated approvers, depending on company settings.
                </Typography>
                <Typography variant="body2" gutterBottom>
                    3. Final Confirmation – Once all required approvals are completed, the shift trade will be
                    finalized, and both employees will receive confirmation.
                </Typography>
                <TextField
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    placeholder="Reason for request"
                    size="small"
                    onChange={(e) => setNote(e.target.value)}
                />
                <Box textAlign="right" marginTop={2}>
                    <Button variant="contained" color="primary" size="small" onClick={onContinue}>
                        Continue
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default TradeShiftInitialStep;
